import React from 'react';

export const Desktop = ({ color }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2770_3781)">
      <path
        d="M12.9414 17.4807V20.0669H9.05956V17.4807H2.58984C1.90349 17.4807 1.24525 17.2082 0.759928 16.7232C0.274605 16.2382 0.00195313 15.5803 0.00195312 14.8944V3.25629C0.00195313 2.57038 0.274605 1.91256 0.759928 1.42754C1.24525 0.942523 1.90349 0.670044 2.58984 0.670044L19.4111 0.670044C20.0975 0.670044 20.7557 0.942523 21.241 1.42754C21.7263 1.91256 21.999 2.57038 21.999 3.25629V14.8944C21.999 15.5803 21.7263 16.2382 21.241 16.7232C20.7557 17.2082 20.0975 17.4807 19.4111 17.4807H12.9414ZM5.17773 20.0669H16.8232V21.36H5.17773V20.0669ZM2.58984 3.25629V14.8944H19.4111V3.25629H2.58984Z"
        fill={color ?? '#005EE0'}
      />
    </g>
    <defs>
      <clipPath id="clip0_2770_3781">
        <rect
          width="22"
          height="20.69"
          fill="white"
          transform="translate(0 0.670044)"
        />
      </clipPath>
    </defs>
  </svg>
);
